import React from "react";
import { pageStyle, sectionWrapperStyle } from "../component/style-variable";

function NotFoundPage(){

    return (
        <div className={`${sectionWrapperStyle} min-h-[calc(100vh-272px)]`}>
            <p className="mt-20 font-ibm font-semibold text-neutral-800 text-2xl">404 Page Not Found</p>
        </div>
    )
}

export default NotFoundPage